import { render, staticRenderFns } from "./DeleteCardModal.vue?vue&type=template&id=4789317d"
import script from "./DeleteCardModal.vue?vue&type=script&lang=js"
export * from "./DeleteCardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports